import "./component-library85.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "Heading",
  props: {
    align: {
      type: String,
      default: void 0,
      validator(value) {
        return ["left", "center", "right", void 0].includes(value);
      }
    },
    size: {
      type: String,
      default: "",
      validator(value) {
        return ["xxs", "xs", "sm", "md", "lg", "xl", "xxl", ""].includes(value);
      }
    },
    theme: {
      type: String,
      default: void 0,
      validator(value) {
        return ["light", "dark", "primary", void 0].includes(value);
      }
    },
    tag: { type: String, default: "h1" },
    fontWeight: { type: String, default: "bold" },
    text: { type: String, default: "" },
    textUppercase: { type: Boolean },
    spacesTop: { type: Boolean },
    spacesBottom: { type: [Boolean, Number], default: false }
  },
  data() {
    return {
      placeholderHeadingSizes: {
        xxl: "h1",
        xl: "h2",
        lg: "h3",
        md: "h4",
        sm: "h5",
        xs: "h6"
      }
    };
  },
  computed: {
    classes() {
      const modifier = [];
      modifier.push("heading");
      if (this.spacesTop)
        modifier.push("heading--spaces-top");
      if (this.spacesBottom)
        modifier.push("heading--spaces-bottom");
      if (this.theme)
        modifier.push(`text--${this.theme}`);
      if (this.align)
        modifier.push(`text--${this.align}`);
      modifier.push(`text--${this.size ? this.placeholderHeadingSizes[this.size] : this.tag}`);
      if (this.fontWeight)
        modifier.push(`text--${this.fontWeight}`);
      if (this.textUppercase)
        modifier.push("text--uppercase");
      return modifier;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return !_vm.text ? _c(_vm.tag, { tag: "component", class: _vm.classes }, [_vm._t("default")], 2) : _c(_vm.tag, { tag: "component", class: _vm.classes, domProps: { "innerHTML": _vm._s(_vm.text) } });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "82143e8a",
  null,
  null
);
const Heading = __component__.exports;
export {
  Heading as default
};
